import { render, staticRenderFns } from "./AvailableProcessDefinitions.vue?vue&type=template&id=04c168e6&scoped=true&"
import script from "./AvailableProcessDefinitions.vue?vue&type=script&lang=js&"
export * from "./AvailableProcessDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c168e6",
  null
  
)

export default component.exports